import { useEffect } from 'react';
import { useMapStore } from 'src/stores';

export default function useMapFilters({ selectedTypes, selectedCountries, favouriteIds, showFavouritesOnly }) {
  const { mapInstance } = useMapStore();

  useEffect(() => {
    if (!mapInstance || !mapInstance.isStyleLoaded()) return;

    const filters = ['all'];

    filters.push(['in', ['get', 'category'], ['literal', selectedTypes]]);
    filters.push(['in', ['get', 'country'], ['literal', selectedCountries]]);

    if (showFavouritesOnly) {
      if (favouriteIds.length > 0) {
        filters.push(['in', ['get', 'id'], ['literal', favouriteIds]]);
      } else {
        filters.push(['==', ['get', 'id'], '___none___']);
      }
    }

    mapInstance.setFilter('panam-symbols', filters);
  }, [mapInstance, selectedTypes, selectedCountries, favouriteIds, showFavouritesOnly]);
}
